import ApiService from '../services/api';
import ActionTemplate from './services/actionTemplate';

const PAYMENT_PXPAY = 'PAYMENT_PXPAY';
const WINDCAVE_PROCESS_PAYMENT = 'WINDCAVE_PROCESS_PAYMENT';
const UPDATE_TOKEN_PAYMENT = 'UPDATE_TOKEN_PAYMENT';
const PAYMENT_TYPES = 'PAYMENT_TYPES';
/** Actions for Payment Token */
export default class PaymentTokenAction {

    constructor() {
        this.api = new ApiService();
        this.actionTemplate = new ActionTemplate();
    }

    /**********************************************************/
    /**********************FETCH PAYMENT***********************/
    /**********************************************************/
  
    fetchWindcavePaymentByToken(token) {
        return (dispatch) => {
            dispatch(this.actionTemplate.request(PAYMENT_PXPAY));
            const url = '/payment_link_pxpay/' + token;
            return this.api.get(url)
                .then((response) => dispatch(this.actionTemplate.success(PAYMENT_PXPAY, response.data)))
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(PAYMENT_PXPAY, err));
                });
        };
    }

    /**********************************************************/
    /**********************FETCH PAYMENT TYPES***********************/
    /**********************************************************/
  
    fetchPaymentTypes() {
        return (dispatch) => {
            dispatch(this.actionTemplate.request(PAYMENT_TYPES));
            const url = '/payment_types';
            return this.api.get(url)
                .then((response) => dispatch(this.actionTemplate.success(PAYMENT_TYPES, response.data)))
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(PAYMENT_TYPES, err));
                });
        };
    }

    /**********************************************************/
    /**********************PROCESS PAYMENT*********************/
    /**********************************************************/

    windcaveProcessPayment(requestBody){
        
        return (dispatch) => {
            dispatch(this.actionTemplate.request(WINDCAVE_PROCESS_PAYMENT));
            const url = '/payment_link_pxpay/response';
            return this.api.post(url, requestBody)
                .then((response) => {
                    if (response.data){
                        dispatch(this.actionTemplate.success(WINDCAVE_PROCESS_PAYMENT, response.data));
                    } else {
                        dispatch(this.actionTemplate.failure(WINDCAVE_PROCESS_PAYMENT, response.error));
                    }
                })
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(WINDCAVE_PROCESS_PAYMENT, err));
                });
        };
    }

    /**********************************************************/
    /*******************UPDATE TOKEN PAYMENT*******************/
    /**********************************************************/

    updateTokenPayment(token, payCode, successRedirectUrl, produceMessage){
        const requestBody = {
            payCode: payCode,
        };
        return (dispatch) => {
            dispatch(this.actionTemplate.request(UPDATE_TOKEN_PAYMENT));
            const url = '/payment_link_pxpay/' + token;
            return this.api.patch(url, requestBody)
                .then((response) => {
                    response.data['successRedirectUrl'] = successRedirectUrl;
                    response.data['produceMessage'] = produceMessage;
                    dispatch(this.actionTemplate.success(UPDATE_TOKEN_PAYMENT, response.data))
                    ;
                })
                .catch((err) => {
                    /* istanbul ignore next */ 
                    dispatch(this.actionTemplate.failure(UPDATE_TOKEN_PAYMENT, err));
                });
        };
    }
}
